import "./MessageCard.scoped.scss";

export enum BackGroundType {
  Handwritten, // 手書き画像
  Img0,
  Img1,
  Img2,
  Img3,
  Img4,
  Img5,
  Img6,
  Img7,
  Img8,
  Img9,
  Img10,
  Img11,
  Max,
}

interface Props {
  readonly name: string;
  readonly twitterID: string;
  readonly message: string;
  readonly backgroundType: BackGroundType;
}

// 1枚分のメッセージカードを表現するコンポーネント
export default function MessageCard(props: Props) {
  if (props.backgroundType >= BackGroundType.Max) {
    throw new Error("サポート外の値");
  }

  if (props.backgroundType === BackGroundType.Handwritten) {
    throw new Error("未実装");
  }

  const id = "@" + props.twitterID;
  const link = "https://twitter.com/" + props.twitterID;
  return (
    <div className={`card_type${props.backgroundType}`}>
      <div className="select-none message">
        <p>{props.message}</p>
      </div>
      <div className="select-none author">
        {props.name}
        <br />
        <a href={link} target="_blank" rel="noreferrer" className="App-link">
          {id}
        </a>
      </div>
    </div>
  );
}
